import { createAction } from "@reduxjs/toolkit";
import api from "../../services/api";

export const getUserStats = createAction("GET_USER_STATS");
export const clearStats = createAction("CLEAR_STATS");
export const handleGetUserStats = (id, dates) => {
  return (dispatch) =>
    api
      .get(`/activedtasks/user/${id}`, { params: dates })
      .then((res) => dispatch(getUserStats(res.data)))
      .catch((err) => Promise.reject(err));
};
